module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"videos":"Video","theory":"Teori","practice":"Praksis","follow":"Følg","unfollow":"Følger"},"en":{"videos":"Video","theory":"Theory","practice":"Practice","follow":"Follow","unfollow":"Following"}}')
  delete Component.options._Ctor
}
